export const GET_REDEEM_OPT = 'GET_REDEEM_OPT';
export const GET_REDEEM_OPT_DATA = 'GET_REDEEM_OPT_DATA';
export const CREATE_NEW_REDEEM_OPT = 'CREATE_NEW_REDEEM_OPT';
export const EDIT_REDEEM_OPT = 'EDIT_REDEEM_OPT';
export const DELETE_REDEEM_OPT = 'DELETE_REDEEM_OPT';
export const TOGGEL_REDEEM_OPT_STATUS = 'TOGGEL_REDEEM_OPT_STATUS';

export const OPEN_REDEEM_OPT_DIALOG = 'OPEN_REDEEM_OPT_DIALOG';
export const CLOSE_REDEEM_OPT_DIALOG = 'CLOSE_REDEEM_OPT_DIALOG';
